import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IGetRewindParams } from '../../entity/interface/iPopcorn';
import { IGenreRatingConfig } from '../../entity/interface/iPopcornResponse';
import { IForgetPinUseCase } from '../../core/usecases/popcorn/ForgetPinUseCase';
import { iGetPromotionsUseCase } from '../../core/usecases/popcorn/GetPromotionsUseCase';
import { iGetRewaindsUseCase } from '../../core/usecases/popcorn/GetRewindsUseCase';
import { IGetByPopcornUrlUseCase } from '../../core/usecases/popcorn/GetByPopcornUrlUseCase';

export interface IPopcornService {
    // do the needful for forgetPin and getPromotions and getRewind
    forgotPin(apikey: string, username: string, identityToken: string, authToken: string): Promise<any>;
    getPromotions(
        apikey: string,
        device: string,
        country: string,
        subscriptionGuids: string,
        tierGuid: string,
        operator: string,
        subStatus: string,
        productKey: string,
        range: string,
        // area: string,
        providers: { [key: string]: { [key: string]: string } },
        lang: string,
        genreRatingConfig: IGenreRatingConfig,
        dataSources: string
    ): Promise<any>;
    getRewind(searchParams: IGetRewindParams): Promise<any>;

    getByPopcornUrl(url: string): Promise<any>;
}

export class PopcornService implements IPopcornService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get forgetPinUseCase(): IForgetPinUseCase {
        return container.resolve<IForgetPinUseCase>(DI.USECASES.IForgetPinUseCase);
    }



    private get getPromotionsUseCase(): iGetPromotionsUseCase {
        return container.resolve<iGetPromotionsUseCase>(DI.USECASES.IGetPromotionsUseCase);
    }

    private get getRewindsUseCase(): iGetRewaindsUseCase {
        return container.resolve<iGetRewaindsUseCase>(DI.USECASES.IGetRewindsUseCase);
    }

    private get getByPopcornUrlUseCase(): IGetByPopcornUrlUseCase {
        return container.resolve<IGetByPopcornUrlUseCase>(DI.USECASES.IGetByPopcornUrlUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async forgotPin(apikey: string, username: string, identityToken: string, authToken: string): Promise<any> {
        return await this.forgetPinUseCase.execute(apikey, username, identityToken, authToken);
    }





    async getPromotions(
        apikey: string,
        device: string,
        country: string,
        subscriptionGuids: string,
        tierGuid: string,
        operator: string,
        subStatus: string,
        productKey: string,
        range: string,
        providers: { [key: string]: { [key: string]: string } },
        lang: string,
        genreRatingConfig: IGenreRatingConfig,
        dataSources: string
    ): Promise<any> {
        return await this.getPromotionsUseCase.execute(
            apikey,
            device,
            country,
            subscriptionGuids,
            tierGuid,
            operator,
            subStatus,
            productKey,
            range,
            providers,
            lang,
            genreRatingConfig,
            dataSources
        );
    }

    async getRewind(searchParams: IGetRewindParams): Promise<any> {
        return await this.getRewindsUseCase.execute(searchParams);
    }

    async getByPopcornUrl(url: string): Promise<any> {
        return await this.getByPopcornUrlUseCase.execute(url);
    }
}
